import { render, staticRenderFns } from "./StepUpload.vue?vue&type=template&id=634d19e7&scoped=true"
import script from "./StepUpload.vue?vue&type=script&lang=js"
export * from "./StepUpload.vue?vue&type=script&lang=js"
import style0 from "./StepUpload.vue?vue&type=style&index=0&id=634d19e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d19e7",
  null
  
)

export default component.exports